/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R403RouteImport } from './routes/403'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SuperuserRouteImport } from './routes/_superuser'
import { Route as ErrorAuthRouteImport } from './routes/error-auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResetPasswordSuccessRouteImport } from './routes/reset-password-success'
import { Route as VerifyMagicLinkRouteImport } from './routes/verify-magic-link'
import { Route as VerifyRequestRouteImport } from './routes/verify-request'
import { Route as AuthenticatedInvoicesRouteImport } from './routes/_authenticated/invoices'
import { Route as AuthenticatedLanguageSettingsRouteImport } from './routes/_authenticated/language-settings'
import { Route as AuthenticatedPriceUpdateRouteImport } from './routes/_authenticated/price-update'
import { Route as AuthenticatedPricesheetRouteImport } from './routes/_authenticated/pricesheet'
import { Route as AuthenticatedSparkspreadDashboardRouteImport } from './routes/_authenticated/sparkspread-dashboard'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedClientCredentialsIndexRouteImport } from './routes/_authenticated/client-credentials/index'
import { Route as AuthenticatedClientCredentialsNewRouteImport } from './routes/_authenticated/client-credentials/new'
import { Route as AuthenticatedClientsheetsIndexRouteImport } from './routes/_authenticated/clientsheets/index'
import { Route as AuthenticatedClientsheetsArchiveRouteImport } from './routes/_authenticated/clientsheets/archive'
import { Route as SuperuserAdminAutoTraderMonitoringRouteImport } from './routes/_superuser/admin/auto-trader-monitoring'
import { Route as SuperuserAdminClientsRouteImport } from './routes/_superuser/admin/clients'
import { Route as SuperuserAdminSparkspreadDashboardRouteImport } from './routes/_superuser/admin/sparkspread-dashboard'
import { Route as SuperuserAdminSuperusersRouteImport } from './routes/_superuser/admin/superusers'
import { Route as SuperuserAdminUserClientLinksRouteImport } from './routes/_superuser/admin/user-client-links'
import { Route as SuperuserAdminAlgoTradingIndexRouteImport } from './routes/_superuser/admin/algo-trading/index'
import { Route as SuperuserAdminAlgoTradingSignalsRouteImport } from './routes/_superuser/admin/algo-trading/signals'
import { Route as SuperuserAdminAlgoTradingSlicesRouteImport } from './routes/_superuser/admin/algo-trading/slices'
import { Route as SuperuserAdminPriceUpdateIndexRouteImport } from './routes/_superuser/admin/price-update/index'
import { Route as SuperuserAdminPriceUpdateReviewUploadRouteImport } from './routes/_superuser/admin/price-update/review-upload'
import { Route as SuperuserAdminPriceUpdateUploadRouteImport } from './routes/_superuser/admin/price-update/upload'
import { Route as SuperuserAdminUserClientLinksIndexRouteImport } from './routes/_superuser/admin/user-client-links/index'
import { Route as SuperuserAdminUsersIndexRouteImport } from './routes/_superuser/admin/users/index'
import { Route as SuperuserAdminUsersNewRouteImport } from './routes/_superuser/admin/users/new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperuserRoute = SuperuserRouteImport.update({
  id: '/_superuser',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorAuthRoute = ErrorAuthRouteImport.update({
  id: '/error-auth',
  path: '/error-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordSuccessRoute = ResetPasswordSuccessRouteImport.update({
  id: '/reset-password-success',
  path: '/reset-password-success',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyMagicLinkRoute = VerifyMagicLinkRouteImport.update({
  id: '/verify-magic-link',
  path: '/verify-magic-link',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRequestRoute = VerifyRequestRouteImport.update({
  id: '/verify-request',
  path: '/verify-request',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedInvoicesRoute = AuthenticatedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLanguageSettingsRoute =
  AuthenticatedLanguageSettingsRouteImport.update({
    id: '/language-settings',
    path: '/language-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPriceUpdateRoute =
  AuthenticatedPriceUpdateRouteImport.update({
    id: '/price-update',
    path: '/price-update',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPricesheetRoute = AuthenticatedPricesheetRouteImport.update({
  id: '/pricesheet',
  path: '/pricesheet',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSparkspreadDashboardRoute =
  AuthenticatedSparkspreadDashboardRouteImport.update({
    id: '/sparkspread-dashboard',
    path: '/sparkspread-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientCredentialsIndexRoute =
  AuthenticatedClientCredentialsIndexRouteImport.update({
    id: '/client-credentials/',
    path: '/client-credentials/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientCredentialsNewRoute =
  AuthenticatedClientCredentialsNewRouteImport.update({
    id: '/client-credentials/new',
    path: '/client-credentials/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsheetsIndexRoute =
  AuthenticatedClientsheetsIndexRouteImport.update({
    id: '/clientsheets/',
    path: '/clientsheets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsheetsArchiveRoute =
  AuthenticatedClientsheetsArchiveRouteImport.update({
    id: '/clientsheets/archive',
    path: '/clientsheets/archive',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const SuperuserAdminAutoTraderMonitoringRoute =
  SuperuserAdminAutoTraderMonitoringRouteImport.update({
    id: '/admin/auto-trader-monitoring',
    path: '/admin/auto-trader-monitoring',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminClientsRoute = SuperuserAdminClientsRouteImport.update({
  id: '/admin/clients',
  path: '/admin/clients',
  getParentRoute: () => SuperuserRoute,
} as any)
const SuperuserAdminSparkspreadDashboardRoute =
  SuperuserAdminSparkspreadDashboardRouteImport.update({
    id: '/admin/sparkspread-dashboard',
    path: '/admin/sparkspread-dashboard',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminSuperusersRoute =
  SuperuserAdminSuperusersRouteImport.update({
    id: '/admin/superusers',
    path: '/admin/superusers',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminUserClientLinksRoute =
  SuperuserAdminUserClientLinksRouteImport.update({
    id: '/admin/user-client-links',
    path: '/admin/user-client-links',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminAlgoTradingIndexRoute =
  SuperuserAdminAlgoTradingIndexRouteImport.update({
    id: '/admin/algo-trading/',
    path: '/admin/algo-trading/',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminAlgoTradingSignalsRoute =
  SuperuserAdminAlgoTradingSignalsRouteImport.update({
    id: '/admin/algo-trading/signals',
    path: '/admin/algo-trading/signals',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminAlgoTradingSlicesRoute =
  SuperuserAdminAlgoTradingSlicesRouteImport.update({
    id: '/admin/algo-trading/slices',
    path: '/admin/algo-trading/slices',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminPriceUpdateIndexRoute =
  SuperuserAdminPriceUpdateIndexRouteImport.update({
    id: '/admin/price-update/',
    path: '/admin/price-update/',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminPriceUpdateReviewUploadRoute =
  SuperuserAdminPriceUpdateReviewUploadRouteImport.update({
    id: '/admin/price-update/review-upload',
    path: '/admin/price-update/review-upload',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminPriceUpdateUploadRoute =
  SuperuserAdminPriceUpdateUploadRouteImport.update({
    id: '/admin/price-update/upload',
    path: '/admin/price-update/upload',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminUserClientLinksIndexRoute =
  SuperuserAdminUserClientLinksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SuperuserAdminUserClientLinksRoute,
  } as any)
const SuperuserAdminUsersIndexRoute =
  SuperuserAdminUsersIndexRouteImport.update({
    id: '/admin/users/',
    path: '/admin/users/',
    getParentRoute: () => SuperuserRoute,
  } as any)
const SuperuserAdminUsersNewRoute = SuperuserAdminUsersNewRouteImport.update({
  id: '/admin/users/new',
  path: '/admin/users/new',
  getParentRoute: () => SuperuserRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/error-auth': typeof ErrorAuthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-success': typeof ResetPasswordSuccessRoute
  '/verify-magic-link': typeof VerifyMagicLinkRoute
  '/verify-request': typeof VerifyRequestRoute
  '/invoices': typeof AuthenticatedInvoicesRoute
  '/language-settings': typeof AuthenticatedLanguageSettingsRoute
  '/price-update': typeof AuthenticatedPriceUpdateRoute
  '/pricesheet': typeof AuthenticatedPricesheetRoute
  '/sparkspread-dashboard': typeof AuthenticatedSparkspreadDashboardRoute
  '/support': typeof AuthenticatedSupportRoute
  '/client-credentials/new': typeof AuthenticatedClientCredentialsNewRoute
  '/clientsheets/archive': typeof AuthenticatedClientsheetsArchiveRoute
  '/admin/auto-trader-monitoring': typeof SuperuserAdminAutoTraderMonitoringRoute
  '/admin/clients': typeof SuperuserAdminClientsRoute
  '/admin/sparkspread-dashboard': typeof SuperuserAdminSparkspreadDashboardRoute
  '/admin/superusers': typeof SuperuserAdminSuperusersRoute
  '/admin/user-client-links': typeof SuperuserAdminUserClientLinksRouteWithChildren
  '/client-credentials/': typeof AuthenticatedClientCredentialsIndexRoute
  '/clientsheets/': typeof AuthenticatedClientsheetsIndexRoute
  '/admin/algo-trading/signals': typeof SuperuserAdminAlgoTradingSignalsRoute
  '/admin/algo-trading/slices': typeof SuperuserAdminAlgoTradingSlicesRoute
  '/admin/price-update/review-upload': typeof SuperuserAdminPriceUpdateReviewUploadRoute
  '/admin/price-update/upload': typeof SuperuserAdminPriceUpdateUploadRoute
  '/admin/users/new': typeof SuperuserAdminUsersNewRoute
  '/admin/algo-trading/': typeof SuperuserAdminAlgoTradingIndexRoute
  '/admin/price-update/': typeof SuperuserAdminPriceUpdateIndexRoute
  '/admin/user-client-links/': typeof SuperuserAdminUserClientLinksIndexRoute
  '/admin/users/': typeof SuperuserAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/error-auth': typeof ErrorAuthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-success': typeof ResetPasswordSuccessRoute
  '/verify-magic-link': typeof VerifyMagicLinkRoute
  '/verify-request': typeof VerifyRequestRoute
  '/invoices': typeof AuthenticatedInvoicesRoute
  '/language-settings': typeof AuthenticatedLanguageSettingsRoute
  '/price-update': typeof AuthenticatedPriceUpdateRoute
  '/pricesheet': typeof AuthenticatedPricesheetRoute
  '/sparkspread-dashboard': typeof AuthenticatedSparkspreadDashboardRoute
  '/support': typeof AuthenticatedSupportRoute
  '/client-credentials/new': typeof AuthenticatedClientCredentialsNewRoute
  '/clientsheets/archive': typeof AuthenticatedClientsheetsArchiveRoute
  '/admin/auto-trader-monitoring': typeof SuperuserAdminAutoTraderMonitoringRoute
  '/admin/clients': typeof SuperuserAdminClientsRoute
  '/admin/sparkspread-dashboard': typeof SuperuserAdminSparkspreadDashboardRoute
  '/admin/superusers': typeof SuperuserAdminSuperusersRoute
  '/client-credentials': typeof AuthenticatedClientCredentialsIndexRoute
  '/clientsheets': typeof AuthenticatedClientsheetsIndexRoute
  '/admin/algo-trading/signals': typeof SuperuserAdminAlgoTradingSignalsRoute
  '/admin/algo-trading/slices': typeof SuperuserAdminAlgoTradingSlicesRoute
  '/admin/price-update/review-upload': typeof SuperuserAdminPriceUpdateReviewUploadRoute
  '/admin/price-update/upload': typeof SuperuserAdminPriceUpdateUploadRoute
  '/admin/users/new': typeof SuperuserAdminUsersNewRoute
  '/admin/algo-trading': typeof SuperuserAdminAlgoTradingIndexRoute
  '/admin/price-update': typeof SuperuserAdminPriceUpdateIndexRoute
  '/admin/user-client-links': typeof SuperuserAdminUserClientLinksIndexRoute
  '/admin/users': typeof SuperuserAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_superuser': typeof SuperuserRouteWithChildren
  '/error-auth': typeof ErrorAuthRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-success': typeof ResetPasswordSuccessRoute
  '/verify-magic-link': typeof VerifyMagicLinkRoute
  '/verify-request': typeof VerifyRequestRoute
  '/_authenticated/invoices': typeof AuthenticatedInvoicesRoute
  '/_authenticated/language-settings': typeof AuthenticatedLanguageSettingsRoute
  '/_authenticated/price-update': typeof AuthenticatedPriceUpdateRoute
  '/_authenticated/pricesheet': typeof AuthenticatedPricesheetRoute
  '/_authenticated/sparkspread-dashboard': typeof AuthenticatedSparkspreadDashboardRoute
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/client-credentials/new': typeof AuthenticatedClientCredentialsNewRoute
  '/_authenticated/clientsheets/archive': typeof AuthenticatedClientsheetsArchiveRoute
  '/_superuser/admin/auto-trader-monitoring': typeof SuperuserAdminAutoTraderMonitoringRoute
  '/_superuser/admin/clients': typeof SuperuserAdminClientsRoute
  '/_superuser/admin/sparkspread-dashboard': typeof SuperuserAdminSparkspreadDashboardRoute
  '/_superuser/admin/superusers': typeof SuperuserAdminSuperusersRoute
  '/_superuser/admin/user-client-links': typeof SuperuserAdminUserClientLinksRouteWithChildren
  '/_authenticated/client-credentials/': typeof AuthenticatedClientCredentialsIndexRoute
  '/_authenticated/clientsheets/': typeof AuthenticatedClientsheetsIndexRoute
  '/_superuser/admin/algo-trading/signals': typeof SuperuserAdminAlgoTradingSignalsRoute
  '/_superuser/admin/algo-trading/slices': typeof SuperuserAdminAlgoTradingSlicesRoute
  '/_superuser/admin/price-update/review-upload': typeof SuperuserAdminPriceUpdateReviewUploadRoute
  '/_superuser/admin/price-update/upload': typeof SuperuserAdminPriceUpdateUploadRoute
  '/_superuser/admin/users/new': typeof SuperuserAdminUsersNewRoute
  '/_superuser/admin/algo-trading/': typeof SuperuserAdminAlgoTradingIndexRoute
  '/_superuser/admin/price-update/': typeof SuperuserAdminPriceUpdateIndexRoute
  '/_superuser/admin/user-client-links/': typeof SuperuserAdminUserClientLinksIndexRoute
  '/_superuser/admin/users/': typeof SuperuserAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/error-auth'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/reset-password-success'
    | '/verify-magic-link'
    | '/verify-request'
    | '/invoices'
    | '/language-settings'
    | '/price-update'
    | '/pricesheet'
    | '/sparkspread-dashboard'
    | '/support'
    | '/client-credentials/new'
    | '/clientsheets/archive'
    | '/admin/auto-trader-monitoring'
    | '/admin/clients'
    | '/admin/sparkspread-dashboard'
    | '/admin/superusers'
    | '/admin/user-client-links'
    | '/client-credentials/'
    | '/clientsheets/'
    | '/admin/algo-trading/signals'
    | '/admin/algo-trading/slices'
    | '/admin/price-update/review-upload'
    | '/admin/price-update/upload'
    | '/admin/users/new'
    | '/admin/algo-trading/'
    | '/admin/price-update/'
    | '/admin/user-client-links/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/error-auth'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/reset-password-success'
    | '/verify-magic-link'
    | '/verify-request'
    | '/invoices'
    | '/language-settings'
    | '/price-update'
    | '/pricesheet'
    | '/sparkspread-dashboard'
    | '/support'
    | '/client-credentials/new'
    | '/clientsheets/archive'
    | '/admin/auto-trader-monitoring'
    | '/admin/clients'
    | '/admin/sparkspread-dashboard'
    | '/admin/superusers'
    | '/client-credentials'
    | '/clientsheets'
    | '/admin/algo-trading/signals'
    | '/admin/algo-trading/slices'
    | '/admin/price-update/review-upload'
    | '/admin/price-update/upload'
    | '/admin/users/new'
    | '/admin/algo-trading'
    | '/admin/price-update'
    | '/admin/user-client-links'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/_authenticated'
    | '/_superuser'
    | '/error-auth'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/reset-password-success'
    | '/verify-magic-link'
    | '/verify-request'
    | '/_authenticated/invoices'
    | '/_authenticated/language-settings'
    | '/_authenticated/price-update'
    | '/_authenticated/pricesheet'
    | '/_authenticated/sparkspread-dashboard'
    | '/_authenticated/support'
    | '/_authenticated/client-credentials/new'
    | '/_authenticated/clientsheets/archive'
    | '/_superuser/admin/auto-trader-monitoring'
    | '/_superuser/admin/clients'
    | '/_superuser/admin/sparkspread-dashboard'
    | '/_superuser/admin/superusers'
    | '/_superuser/admin/user-client-links'
    | '/_authenticated/client-credentials/'
    | '/_authenticated/clientsheets/'
    | '/_superuser/admin/algo-trading/signals'
    | '/_superuser/admin/algo-trading/slices'
    | '/_superuser/admin/price-update/review-upload'
    | '/_superuser/admin/price-update/upload'
    | '/_superuser/admin/users/new'
    | '/_superuser/admin/algo-trading/'
    | '/_superuser/admin/price-update/'
    | '/_superuser/admin/user-client-links/'
    | '/_superuser/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SuperuserRoute: typeof SuperuserRouteWithChildren
  ErrorAuthRoute: typeof ErrorAuthRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ResetPasswordSuccessRoute: typeof ResetPasswordSuccessRoute
  VerifyMagicLinkRoute: typeof VerifyMagicLinkRoute
  VerifyRequestRoute: typeof VerifyRequestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_superuser': {
      id: '/_superuser'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SuperuserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error-auth': {
      id: '/error-auth'
      path: '/error-auth'
      fullPath: '/error-auth'
      preLoaderRoute: typeof ErrorAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-success': {
      id: '/reset-password-success'
      path: '/reset-password-success'
      fullPath: '/reset-password-success'
      preLoaderRoute: typeof ResetPasswordSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-magic-link': {
      id: '/verify-magic-link'
      path: '/verify-magic-link'
      fullPath: '/verify-magic-link'
      preLoaderRoute: typeof VerifyMagicLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-request': {
      id: '/verify-request'
      path: '/verify-request'
      fullPath: '/verify-request'
      preLoaderRoute: typeof VerifyRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/invoices': {
      id: '/_authenticated/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedInvoicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/language-settings': {
      id: '/_authenticated/language-settings'
      path: '/language-settings'
      fullPath: '/language-settings'
      preLoaderRoute: typeof AuthenticatedLanguageSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/price-update': {
      id: '/_authenticated/price-update'
      path: '/price-update'
      fullPath: '/price-update'
      preLoaderRoute: typeof AuthenticatedPriceUpdateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pricesheet': {
      id: '/_authenticated/pricesheet'
      path: '/pricesheet'
      fullPath: '/pricesheet'
      preLoaderRoute: typeof AuthenticatedPricesheetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sparkspread-dashboard': {
      id: '/_authenticated/sparkspread-dashboard'
      path: '/sparkspread-dashboard'
      fullPath: '/sparkspread-dashboard'
      preLoaderRoute: typeof AuthenticatedSparkspreadDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-credentials/': {
      id: '/_authenticated/client-credentials/'
      path: '/client-credentials'
      fullPath: '/client-credentials/'
      preLoaderRoute: typeof AuthenticatedClientCredentialsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-credentials/new': {
      id: '/_authenticated/client-credentials/new'
      path: '/client-credentials/new'
      fullPath: '/client-credentials/new'
      preLoaderRoute: typeof AuthenticatedClientCredentialsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clientsheets/': {
      id: '/_authenticated/clientsheets/'
      path: '/clientsheets'
      fullPath: '/clientsheets/'
      preLoaderRoute: typeof AuthenticatedClientsheetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clientsheets/archive': {
      id: '/_authenticated/clientsheets/archive'
      path: '/clientsheets/archive'
      fullPath: '/clientsheets/archive'
      preLoaderRoute: typeof AuthenticatedClientsheetsArchiveRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_superuser/admin/auto-trader-monitoring': {
      id: '/_superuser/admin/auto-trader-monitoring'
      path: '/admin/auto-trader-monitoring'
      fullPath: '/admin/auto-trader-monitoring'
      preLoaderRoute: typeof SuperuserAdminAutoTraderMonitoringRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/clients': {
      id: '/_superuser/admin/clients'
      path: '/admin/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof SuperuserAdminClientsRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/sparkspread-dashboard': {
      id: '/_superuser/admin/sparkspread-dashboard'
      path: '/admin/sparkspread-dashboard'
      fullPath: '/admin/sparkspread-dashboard'
      preLoaderRoute: typeof SuperuserAdminSparkspreadDashboardRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/superusers': {
      id: '/_superuser/admin/superusers'
      path: '/admin/superusers'
      fullPath: '/admin/superusers'
      preLoaderRoute: typeof SuperuserAdminSuperusersRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/user-client-links': {
      id: '/_superuser/admin/user-client-links'
      path: '/admin/user-client-links'
      fullPath: '/admin/user-client-links'
      preLoaderRoute: typeof SuperuserAdminUserClientLinksRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/algo-trading/': {
      id: '/_superuser/admin/algo-trading/'
      path: '/admin/algo-trading'
      fullPath: '/admin/algo-trading/'
      preLoaderRoute: typeof SuperuserAdminAlgoTradingIndexRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/algo-trading/signals': {
      id: '/_superuser/admin/algo-trading/signals'
      path: '/admin/algo-trading/signals'
      fullPath: '/admin/algo-trading/signals'
      preLoaderRoute: typeof SuperuserAdminAlgoTradingSignalsRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/algo-trading/slices': {
      id: '/_superuser/admin/algo-trading/slices'
      path: '/admin/algo-trading/slices'
      fullPath: '/admin/algo-trading/slices'
      preLoaderRoute: typeof SuperuserAdminAlgoTradingSlicesRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/price-update/': {
      id: '/_superuser/admin/price-update/'
      path: '/admin/price-update'
      fullPath: '/admin/price-update/'
      preLoaderRoute: typeof SuperuserAdminPriceUpdateIndexRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/price-update/review-upload': {
      id: '/_superuser/admin/price-update/review-upload'
      path: '/admin/price-update/review-upload'
      fullPath: '/admin/price-update/review-upload'
      preLoaderRoute: typeof SuperuserAdminPriceUpdateReviewUploadRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/price-update/upload': {
      id: '/_superuser/admin/price-update/upload'
      path: '/admin/price-update/upload'
      fullPath: '/admin/price-update/upload'
      preLoaderRoute: typeof SuperuserAdminPriceUpdateUploadRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/user-client-links/': {
      id: '/_superuser/admin/user-client-links/'
      path: '/'
      fullPath: '/admin/user-client-links/'
      preLoaderRoute: typeof SuperuserAdminUserClientLinksIndexRouteImport
      parentRoute: typeof SuperuserAdminUserClientLinksRoute
    }
    '/_superuser/admin/users/': {
      id: '/_superuser/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof SuperuserAdminUsersIndexRouteImport
      parentRoute: typeof SuperuserRoute
    }
    '/_superuser/admin/users/new': {
      id: '/_superuser/admin/users/new'
      path: '/admin/users/new'
      fullPath: '/admin/users/new'
      preLoaderRoute: typeof SuperuserAdminUsersNewRouteImport
      parentRoute: typeof SuperuserRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedInvoicesRoute: typeof AuthenticatedInvoicesRoute
  AuthenticatedLanguageSettingsRoute: typeof AuthenticatedLanguageSettingsRoute
  AuthenticatedPriceUpdateRoute: typeof AuthenticatedPriceUpdateRoute
  AuthenticatedPricesheetRoute: typeof AuthenticatedPricesheetRoute
  AuthenticatedSparkspreadDashboardRoute: typeof AuthenticatedSparkspreadDashboardRoute
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedClientCredentialsNewRoute: typeof AuthenticatedClientCredentialsNewRoute
  AuthenticatedClientsheetsArchiveRoute: typeof AuthenticatedClientsheetsArchiveRoute
  AuthenticatedClientCredentialsIndexRoute: typeof AuthenticatedClientCredentialsIndexRoute
  AuthenticatedClientsheetsIndexRoute: typeof AuthenticatedClientsheetsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedInvoicesRoute: AuthenticatedInvoicesRoute,
  AuthenticatedLanguageSettingsRoute: AuthenticatedLanguageSettingsRoute,
  AuthenticatedPriceUpdateRoute: AuthenticatedPriceUpdateRoute,
  AuthenticatedPricesheetRoute: AuthenticatedPricesheetRoute,
  AuthenticatedSparkspreadDashboardRoute:
    AuthenticatedSparkspreadDashboardRoute,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedClientCredentialsNewRoute:
    AuthenticatedClientCredentialsNewRoute,
  AuthenticatedClientsheetsArchiveRoute: AuthenticatedClientsheetsArchiveRoute,
  AuthenticatedClientCredentialsIndexRoute:
    AuthenticatedClientCredentialsIndexRoute,
  AuthenticatedClientsheetsIndexRoute: AuthenticatedClientsheetsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface SuperuserAdminUserClientLinksRouteChildren {
  SuperuserAdminUserClientLinksIndexRoute: typeof SuperuserAdminUserClientLinksIndexRoute
}

const SuperuserAdminUserClientLinksRouteChildren: SuperuserAdminUserClientLinksRouteChildren =
  {
    SuperuserAdminUserClientLinksIndexRoute:
      SuperuserAdminUserClientLinksIndexRoute,
  }

const SuperuserAdminUserClientLinksRouteWithChildren =
  SuperuserAdminUserClientLinksRoute._addFileChildren(
    SuperuserAdminUserClientLinksRouteChildren,
  )

interface SuperuserRouteChildren {
  SuperuserAdminAutoTraderMonitoringRoute: typeof SuperuserAdminAutoTraderMonitoringRoute
  SuperuserAdminClientsRoute: typeof SuperuserAdminClientsRoute
  SuperuserAdminSparkspreadDashboardRoute: typeof SuperuserAdminSparkspreadDashboardRoute
  SuperuserAdminSuperusersRoute: typeof SuperuserAdminSuperusersRoute
  SuperuserAdminUserClientLinksRoute: typeof SuperuserAdminUserClientLinksRouteWithChildren
  SuperuserAdminAlgoTradingSignalsRoute: typeof SuperuserAdminAlgoTradingSignalsRoute
  SuperuserAdminAlgoTradingSlicesRoute: typeof SuperuserAdminAlgoTradingSlicesRoute
  SuperuserAdminPriceUpdateReviewUploadRoute: typeof SuperuserAdminPriceUpdateReviewUploadRoute
  SuperuserAdminPriceUpdateUploadRoute: typeof SuperuserAdminPriceUpdateUploadRoute
  SuperuserAdminUsersNewRoute: typeof SuperuserAdminUsersNewRoute
  SuperuserAdminAlgoTradingIndexRoute: typeof SuperuserAdminAlgoTradingIndexRoute
  SuperuserAdminPriceUpdateIndexRoute: typeof SuperuserAdminPriceUpdateIndexRoute
  SuperuserAdminUsersIndexRoute: typeof SuperuserAdminUsersIndexRoute
}

const SuperuserRouteChildren: SuperuserRouteChildren = {
  SuperuserAdminAutoTraderMonitoringRoute:
    SuperuserAdminAutoTraderMonitoringRoute,
  SuperuserAdminClientsRoute: SuperuserAdminClientsRoute,
  SuperuserAdminSparkspreadDashboardRoute:
    SuperuserAdminSparkspreadDashboardRoute,
  SuperuserAdminSuperusersRoute: SuperuserAdminSuperusersRoute,
  SuperuserAdminUserClientLinksRoute:
    SuperuserAdminUserClientLinksRouteWithChildren,
  SuperuserAdminAlgoTradingSignalsRoute: SuperuserAdminAlgoTradingSignalsRoute,
  SuperuserAdminAlgoTradingSlicesRoute: SuperuserAdminAlgoTradingSlicesRoute,
  SuperuserAdminPriceUpdateReviewUploadRoute:
    SuperuserAdminPriceUpdateReviewUploadRoute,
  SuperuserAdminPriceUpdateUploadRoute: SuperuserAdminPriceUpdateUploadRoute,
  SuperuserAdminUsersNewRoute: SuperuserAdminUsersNewRoute,
  SuperuserAdminAlgoTradingIndexRoute: SuperuserAdminAlgoTradingIndexRoute,
  SuperuserAdminPriceUpdateIndexRoute: SuperuserAdminPriceUpdateIndexRoute,
  SuperuserAdminUsersIndexRoute: SuperuserAdminUsersIndexRoute,
}

const SuperuserRouteWithChildren = SuperuserRoute._addFileChildren(
  SuperuserRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SuperuserRoute: SuperuserRouteWithChildren,
  ErrorAuthRoute: ErrorAuthRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ResetPasswordSuccessRoute: ResetPasswordSuccessRoute,
  VerifyMagicLinkRoute: VerifyMagicLinkRoute,
  VerifyRequestRoute: VerifyRequestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
